module.exports = __webpack_public_path__ + "img/shop6.d0612495.png";